import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { TransformProvider } from "./transform-provider";

/**
 * The `ClickZoomHandler` allows the user to zoom the map at a point by double clicking
 * It is used by other handlers
 */
export class ClickZoomHandler {
  /** @internal */
  constructor(map) {
    _defineProperty(this, "_tr", void 0);
    _defineProperty(this, "_enabled", void 0);
    _defineProperty(this, "_active", void 0);
    this._tr = new TransformProvider(map);
    this.reset();
  }
  reset() {
    this._active = false;
  }
  dblclick(e, point) {
    e.preventDefault();
    return {
      cameraAnimation: map => {
        map.easeTo({
          duration: 300,
          zoom: this._tr.zoom + (e.shiftKey ? -1 : 1),
          around: this._tr.unproject(point)
        }, {
          originalEvent: e
        });
      }
    };
  }
  enable() {
    this._enabled = true;
  }
  disable() {
    this._enabled = false;
    this.reset();
  }
  isEnabled() {
    return this._enabled;
  }
  isActive() {
    return this._active;
  }
}